<template>
  <div class="fission-noData text-center" :class="{'height100':height==='100'}" id="noData">
    <p v-if="isImg==='1'">
      <img :src="img || defaultImg" class="imgW"/>
    </p>
    <p class="text-faded" v-if="isText==='1'">{{text}}</p>
    <p class="jumpBtn" v-if="isBtn.isClick===1">
      <span class="fission-pageJumpBtn" @click="jumpTo">{{isBtn.name}}</span>
    </p>
    <p class="jumpBtn" v-if="hasNet">
      <span class="fission-getReloadData" @click="reloadData">点击重新加载</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'no-data',
  props: {
    height: {
      type: String,
      default: '100',
    },
    img: {
      type: String,
      default: '',
    },
    isImg: {
      type: String,
      default: '1',
    },
    text: {
      type: String,
      default: '暂时还没有数据哦！',
    },
    isText: {
      type: String,
      default: '1',
    },
    isBtn: {
      type: Object,
      default() {
        return {
          url: '',
          isClick: 0,
          name: '去首页看看',
        };
      },
    },
    hasNet: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultImg() {
      return this.$fission.setLocalStatics('default/404.png');
    }
  },
  methods: {
    jumpTo() {
      const t = this;
      if (t.isBtn.url && t.isBtn.url.length) {
        t.$router.push({
          path: t.isBtn.url,
        });
        return;
      }
      this.$emit('active');
    },
    reloadData() {
      this.$emit('reload');
    },
  },
};
</script>

<style lang="less" scoped>
  #noData{
    position:relative;
    z-index: 2;
    color: #333;
    .imgW{
      width:auto;
      max-width:100%;
    }
    .jumpBtn{
      height:2em;
      line-height:2em;
      z-index: 99;
      span{
        border-radius:0.3em;
        padding:0.5em 2em;
      }
    }
  }
  .height100{
    height:100vh;
  }
  .fission-noData{
    padding:0.5em 0;
  }
  .fission-pageJumpBtn{
    background:#F6B23B!important;
    color:#ffffff!important;
    height:2em;
    line-height:2em;
  }
  .fission-getReloadData{
    background:#F6B23B!important;
    color:#ffffff!important;
    height:2em;
    line-height:2em;
  }
</style>
